import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const createWorkVideoEducationModalEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-create-work-video-education-modal" */ './src/ui/CreateWorkVideoEducationModal'
			),
	),
	getPreloadProps: () => ({}),
});
